export default "__VITE_ASSET__ur8HbA5O__"